import { issueCategorySchema } from '@sophocles/entities/IssueCategory';
import { Record } from 'immutable';
import { schema } from 'normalizr';

export const IssueSubCategory = new Record({
  id: undefined,
  name: null,
  obsolete: undefined,
  category: null,
});

export const issueSubCategorySchema = new schema.Entity('issueSubCategories', { category: issueCategorySchema });
